<script>
export default {
  name: 'EvolutionConfig',
};
</script>

<template>
  <div class="evolution-iframe-wrapper">
    <iframe
      src="https://rank.agentesai.top/app/login"
      width="100%"
      height="100%"
      frameborder="0"
      allowfullscreen
    />
  </div>
</template>

<style scoped>
.evolution-iframe-wrapper {
  width: 100%;
  min-height: 85vh;
  height: calc(100vh - 100px);
  margin: 0;
  padding: 0;
  background: transparent;
  display: flex;
  flex-direction: column;
  flex: 1 1 auto;
}
.evolution-iframe-wrapper iframe {
  flex: 1 1 auto;
  width: 100%;
  height: 100%;
  min-height: 85vh;
  border: 0;
}
</style>
